import type { OperatorApiScope } from "./api";

export function operatorApiScopesForSelection(
  scopes: readonly OperatorApiScope[] | null | undefined,
): readonly OperatorApiScope[] {
  return scopes ?? [];
}

export function formatOperatorApiScopes(
  scopes: readonly OperatorApiScope[] | null | undefined,
): string {
  if (scopes == null) {
    return "not configured";
  }
  if (scopes.length === 0) {
    return "configured empty";
  }
  return scopes.join(", ");
}
